import styled from "styled-components";

export const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: end;
  justify-content: right;
  width: 1300px;
  height: 84px;
  margin-top: 24px;
  margin-bottom: 57px;
  box-sizing: border-box;
  @media (max-width: 1400px) {
    width: 1087px;
  }
`;

export const CaptchaCotainer = styled.div`
  display: flex;
  align-items: end;
  justify-content: left;
  width: 334px;
  height: 100%;
  margin-right: auto;
  border-radius: 4px;
  box-sizing: border-box;
`;
